// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--df474";
export var content = "Footer-module--content--5eaf6";
export var logo = "Footer-module--logo--4bd03";
export var menus = "Footer-module--menus--de40a";
export var textContainer = "Footer-module--text-container--a589d";